import React from "react";
import { Link } from "react-scroll";
import { ImCircleDown, ImGithub, ImTwitter, ImLinkedin } from "react-icons/im";

function Home() {
  return (
    <>
      <div
        class='bg-[url("https://res.cloudinary.com/vivekiscoding/image/upload/v1667156116/vivekanand/images/bg.jpg")] h-screen w-full bg-cover bg-center'
        id="home"
      >
        <h1 className="mb-2 pt-64 text-6xl font-bold text-center text-white">
          I'm Vivekanand Padala.
        </h1>
        <p className="text-xl text-center pt-4 text-white">
          Front-end web developer based in India.
        </p>
        <span className="flex justify-center pt-6">
          <ImGithub className="basis-28 h-10 w-10 text-white cursor-pointer" />
          <ImTwitter className="basis-28 h-10 w-10 text-white cursor-pointer" />
          <ImLinkedin className="basis-28 h-10 w-10 text-white cursor-pointer" />
        </span>
        <Link
          to="about"
          spy={true}
          smooth={true}
          offset={-70}
          duration={500}
          className="flex justify-center pt-24"
        >
          <ImCircleDown className="h-10 w-10 align-middle text-white  cursor-pointer animate-bounce" />
        </Link>
      </div>
    </>
  );
}

export default Home;
